import styled from 'styled-components';
import theme from 'styles/theme';

export const Container = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: Row;
  gap: 20px;
  &.container-appointment {
    padding: 0;
  }
`;

export const Content = styled.div`
  border-radius: 10px;
  border: 0.4px solid rgba(212, 216, 221, 0.5);
  background: #fff;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;

  .uploaded-files-wrapper {
    flex-wrap: wrap;
  }
`;

export const ColumnContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
`;

export const HeaderContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  border-bottom: 0.4px solid rgba(212, 216, 221, 0.5);
  padding-bottom: 20px;
`;

export const Title = styled.h1`
  color: #212529;
  font-size: 20px;
  font-weight: 600;
  line-height: 24px;
  word-break: break-word;
  overflow-wrap: break-word;
  max-width: 80%;
  cursor: pointer;
`;

export const DetailsRow = styled.div`
  display: flex;
  gap: 5px;
  align-items: center;
`;

export const AssigneeWatcherWrapper = styled.div`
  display: flex;
  gap: 5px;
  align-items: start;
`;

export const DetailHeaderTitle = styled.p`
  color: #6c757d;
  font-size: 14px;
  line-height: 24px;
`;

export const DetailTitle = styled.p`
  color: #6c757d;
  font-size: 14px;
  line-height: 24px;
  min-width: 130px;
`;

export const DetailInfo = styled.p`
  color: #212529;
  font-size: 14px;
  font-weight: 600;
  line-height: 24px;
  cursor: pointer;
`;

export const CustomerInfo = styled.p`
  font-weight: 600;
  font-style: SemiBold;
  font-size: 12px;
  line-height: 24px;
  letter-spacing: 0px;
  vertical-align: middle;
  text-decoration: underline;
  text-decoration-style: solid;
  text-decoration-thickness: 0%;
  margin-left: 7px;
  color: #2d6cdf;
  cursor: ${({ $disabled }) => ($disabled ? 'default' : 'pointer')};
  text-decoration: ${({ $disabled }) => ($disabled ? 'none' : 'underline')};
  opacity: ${({ $disabled }) => ($disabled ? '0.8' : '1')};
`;

export const ContractsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-left: 23px;
`;

export const ContractItem = styled.p`
  font-weight: 500;
  font-size: 12px;
  line-height: 20px;
  color: #2d6cdf;
  cursor: pointer;
  text-decoration: underline;

  &:hover {
    opacity: 0.7;
  }
`;

export const RowWithSpace = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;

  button {
    max-width: 75px;
    height: 32px;

    color: #212529;
    font-size: 12px;
    font-weight: 700;
    line-height: 150%;
  }

  @media screen and (max-width: 1256px) {
    flex-wrap: wrap;
  }
`;

export const CommentArea = styled.div`
  margin-top: 25px;
  word-wrap: break-word;
  overflow-wrap: break-word;
  border-radius: 20px;
  border: 1px solid #d4d8dd;
  background: #fbfcff;
  width: 100%;
  padding: 20px;

  color: #212529;
  font-size: 14px;
  font-weight: 400;
  line-height: 21px; /* 150% */
`;

export const Icon = styled.img`
  width: 15px;
  height: 15px;
`;

export const NestedIcon = styled.img``;

export const FieldItemRow = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const AssigneeWatchersWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  gap: 8px;
  padding: 5px;
`;

export const AssigneeShowWatchersWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  gap: 8px;
  width: 100%;
  padding: 5px 10px 5px 10px;
`;

export const ShowAll = styled.div`
  min-width: 230px;
  background-color: #ffffff;
  border-radius: 10px;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  position: absolute;
  bottom: -12px;
  transform: translate(0, 100%);
  z-index: 999999;

  p {
    word-wrap: break-word;
    overflow-wrap: break-word;
    white-space: normal;
  }

  @media screen and (max-width: 450px) {
    transform: translate(-30%, 100%);
    min-width: 200px;
  }
`;

export const AssigneeAllWatchersWrapper = styled.div`
  display: block;
  align-items: center;
  flex-direction: row;
  gap: 8px;
`;

export const DescriptionView = styled.div`
  overflow-wrap: break-word;
  word-wrap: break-word;
`;

export const AttachmentText = styled.p`
  color: #6c757d;
  font-size: 14px;
  font-weight: 600;
  line-height: 24px; /* 171.429% */
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const AttachmentWrapper = styled.div`
  height: 46px;
  border-radius: 8px;
  background: #fbfcff;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 16px 12px 0;
  cursor: pointer;
`;

export const ColumnInfo = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: 25px;
`;

export const ColumnAssignee = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: 8px;
  position: relative;
`;

export const CommentText = styled.div`
  color: #212529;
  font-size: 14px;
  line-height: 21px;
  max-height: 200px;
  width: 100%;

  overflow-y: auto;
  mask-image: linear-gradient(#000, #000);
  -webkit-mask-image: linear-gradient(#000, #000);

  &::-webkit-scrollbar {
    width: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #888;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background-color: #555;
  }
`;

export const ParentTaskNavigationWrapper = styled.div`
  border-radius: 10px;
  background: #ecf1fb;
  padding: 10px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  cursor: pointer;

  &:hover {
    opacity: 0.6;
  }
`;

export const BackToListBtn = styled.div`
  border-radius: 10px;
  border: 0.4px solid #d4d8dd;
  background: #fff;
  width: 100px;
  height: 40px;
  color: #1d3557;
  text-align: center;
  font-size: 14px;
  font-weight: 600;
  line-height: 9px; /* 64.286% */

  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  &:hover {
    opacity: 0.6;
  }
`;

export const TabButton = styled.button`
  line-height: 9px;
  padding: 17px 25px;
  font-size: 14px;
  color: ${({ $isActive }) =>
    $isActive ? theme.colors.secondary : theme.colors.secondaryText};
  background-color: transparent;
  border: none;
  cursor: pointer;
  font-weight: ${({ $isActive }) => ($isActive ? '700' : '400')};
  text-align: center;
  position: relative;

  &:hover {
    color: ${theme.colors.secondary};
  }

  &::after {
    content: '';
    position: absolute;
    bottom: 4px;
    left: 50%;
    transform: translate(-50%, 50%);
    width: 37px;
    height: 3px;
    background-color: ${theme.colors.secondary};
    border-radius: 3px 3px 0px 0px;
    opacity: ${({ $isActive }) => ($isActive ? '1' : '0')};
    transition: opacity 0.3s ease;
  }
`;

export const TabContainer = styled.div`
  display: flex;
  background-color: ${theme.colors.white};
  border-radius: 10px;
  width: 200px;
  border: 0.4px solid ${theme.colors.borderColor}80;
  justify-content: space-around;
  height: 40px;
  align-items: center;
`;

export const NavigationWrapper = styled.div`
  padding: 20px 20px 0 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;

export const CopySvg = styled.img`
  width: 17px;
  height: 17px;
`;

export const SwitchWrapper = styled.div`
  display: flex;
  gap: 10px;
  width: 100%;
  font-size: 14px;
  color: #6c757d;
  font-style: normal;
  font-weight: 400px;
`;

export const CustomerInfoWrapper = styled.div`
  @media screen and (max-width: 1256px) {
    margin-bottom: 25px;
  }
`;

export const SubtasksWrapper = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 10px;
  border: 0.4px solid rgba(212, 216, 221, 0.5);
`;

export const SubtaskRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 10px;
  border-bottom-right-radius: ${({ $isLast }) => ($isLast ? '10px' : '0')};
  border-bottom-left-radius: ${({ $isLast }) => ($isLast ? '10px' : '0')};
  border-top-right-radius: ${({ $isFirst }) => ($isFirst ? '10px' : '0')};
  border-top-left-radius: ${({ $isFirst }) => ($isFirst ? '10px' : '0')};
  cursor: pointer;
  transition:
    background 0.2s ease,
    transform 0.2s ease,
    box-shadow 0.2s ease;
  &:hover {
    background: #f8f9fa;
  }
  @media (max-width: 570px) {
    flex-wrap: wrap;
    justify-content: flex-start;
    text-align: center;
  }
`;

export const Row = styled.div`
  /* width: calc(100% - 40px);
  height: 0.2px;
  margin: auto;
  background-color: rgba(212, 216, 221, 0.5); */
  display: flex;
  gap: 10px;
  margin-bottom: 25px;
  &:last-child {
    margin-bottom: 0;
  }
`;

export const SubtaskTitle = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: #212529;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 60%;
`;

export const SubtaskAssignee = styled.div`
  font-size: 18px;
  color: #212529;
  font-weight: 400;
  font-size: 14px;
`;

export const SubtaskTextBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
`;

export const SubtaskProgress = styled.div`
  font-size: 18px;
  font-weight: 600;
  color: #6c757d;
`;

export const SubtaskTagWrapper = styled.div`
  width: fit-content;
  justify-self: start;
`;

export const SubtaskAssigneeWrapper = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  padding: 0 14px;
  width: 50%;

  &.right {
    gap: 15px;
    justify-content: flex-end;
  }
  @media (max-width: 570px) {
    flex: 0 0 100%;
    justify-content: flex-start;
  }
`;

export const UserName = styled.div`
  font-weight: 400;
  font-size: 0.875rem;
  word-break: break-word;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
export const TabAppointment = styled.div``;
export const TabAttachments = styled.div``;
export const TabItem = styled.div`
  padding: 10px 0;
  font-weight: 500;
  cursor: pointer;
  position: relative;
  display: flex;
  align-items: center;
  gap: 5px;
  color: ${({ $active }) => ($active ? '#2563EB' : '#6B7280')};

  &:after {
    content: '';
    position: absolute;
    bottom: -1px;
    left: 0;
    height: 2px;
    width: 100%;
    background: ${({ $active }) => ($active ? '#2563EB' : 'transparent')};
    transition: 0.3s;
  }
  @media (max-width: 508px) {
    font-size: 13px;
  }
  @media (max-width: 451px) {
    font-size: 11px;
  }
`;
export const TabHeader = styled.div`
  display: flex;
  gap: 30px;
  border-bottom: 1px solid #e5e7eb;
  width: max-content;
  @media (max-width: 451px) {
    gap: 15px;
  }
`;
export const MarginRightFifty = styled.p``;
export const WeeklyLine = styled.div``;
export const DisplayFlex = styled.div``;
export const MarginWeekDay = styled.p``;
export const Details = styled.div`
  width: 100%;
`;
export const CloseContainer = styled.div``;
export const CloseIconWrapper = styled.div``;
export const DetailColumn = styled.div`
  display: flex;
  @media (max-width: 991px) {
    flex-direction: column;
  }
`;
export const DetailIcon = styled.img`
  width: 17px;
`;
export const AppointmentLabel = styled.p`
  min-width: 130px;
  font-weight: 600;
  font-size: 12px;
  color: #6c757d;
  vertical-align: middle;
`;
export const AppointmentValue = styled.p`
  font-weight: 400;
  font-size: 14px;
  color: #212529;
`;
export const DescriptionArea = styled.div`
  overflow-wrap: break-word;
  word-wrap: break-word;
  word-break: break-word;
  white-space: pre-wrap;
  max-width: 100%;
  overflow: hidden;
`;

export const AppointmentInfoLine = styled.div`
  display: flex;
  justify-content: start;
  gap: 10px;
  align-items: center;
`;
export const AppointmentFlex = styled.div`
  flex: 1;
  @media (max-width: 991px) {
    &:last-child {
      margin-top: 25px;
    }
  }
`;
